import { useState, useEffect } from 'react';
import { getConfig, updateConfig } from '../../api/settings';
import { Input, message, List, Slider } from 'antd';


const UsersTokenConfig = () => {

	const [formState, setFormState] = useState({});
	const [isEditing, setIsEditing] = useState(false);

	const getConfigData = async () => {
		try {
			const response = await getConfig();
			if (response) {
				setFormState((prevState) => ({
					...prevState,
					tokens: response?.tokens
				}));
			}
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getConfigData();
	}, []);

	const handleUpdateClick = async () => {
		setIsEditing(!isEditing);
		if (isEditing) {
			const response = await updateConfig(formState);
			if (response) {
				message.success(response.message);
				getConfigData();
			} else {
				message.error(response.message);
			}
		}
	};


	const maxTokenData = [
		{
			title: 'Max Users Token',
			description: formState?.tokens || '',
		},

	];

	return (
		<>
			<List
				header={<div>Change Settings</div>}
				size="medium"
				bordered
				dataSource={maxTokenData}
				renderItem={(item) => (
					<List.Item>
						<List.Item.Meta
							title={item.title}
							description={
								item.title === 'Max Users Token' ? (
									<Slider
										min={0}
										max={100000}
										step={10}
										value={formState.tokens || 0}
										onChange={(value) =>
											setFormState({
												...formState,
												tokens: value,
											})
										}
										disabled={!isEditing} // Disable slider if not editing
										style={{ width: '300px' }}
									/>
								) : (
									item.description
								)
							}
						/>
					</List.Item>
				)}
			/>
			<div className="text-end">
				<a
					onClick={handleUpdateClick}
					key="list-loadmore-edit"
					className="btn btn-outline-dark"
				>
					{isEditing ? 'Update' : 'Edit'}
				</a>
				{isEditing && (
					<a
						onClick={() => setIsEditing(!isEditing)}
						key="list-loadmore-cancel"
						class="btn btn-outline-dark"
					>
						Cancel
					</a>
				)}
			</div>
		</>
	);
};

export default UsersTokenConfig;
